import type { ModifiersType } from '@utils';
import { appendClassNames, createClsNameMap, mergeModifiers } from '@utils';

export const clsNameMap = createClsNameMap({
  modifiers: [
    'circle',
    'square',
    'round',
    'full-width',
    'hidden',
    'transparent',
    'left',
    'center',
    'right',
    'border',
    // TODO: need review theme-vars first
    'large',
    'primary',
    'secondary',
    'float',
    'show-on-hover',
    'half-width',
  ],
})('button');

export type ButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  modifiers?: ModifiersType<typeof clsNameMap, true>;
};

const Button = ({ children, modifiers, className, style, ...attrs }: ButtonProps) => {
  return (
    <button
      type='button'
      style={style}
      {...attrs}
      className={appendClassNames(mergeModifiers(clsNameMap, [modifiers]), className)}
    >
      {children}
    </button>
  );
};

export default Button;
